export default {"src":"/_next/static/media/de.ca94c213.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};